<template>
  <div
    class="bottom-slide-progress-bar"
    :class="{'is-exporting-pdf': isScreenCapture}"
    id="bottom-progress-bar"
  >
    <div
      class="slide-progress-bar"
      :style="{backgroundColor: $store.state.slideActive.textColour || '#313131', width: percentProgress}"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      percentProgress: `${0}%`,
    }
  },
  computed: {
    ...mapState({
      isScreenCapture: (state) => state.isScreenCapture,
    }),
  },
  watch: {
    // eslint-disable-next-line func-names
    '$store.state.slideActive.id': function () {
      this.getDataProgress()
    },
  },

  mounted() {
    this.getDataProgress()
  },

  methods: {
    getDataProgress() {
      if (!this.$store.state.slideActive.id) return
      const index = this.$store.state.presentation.slides.findIndex((item) => {
        return item.id == this.$store.state.slideActive.id
      })
      if (index != -1) {
        this.percentProgress = `${(index + 1) / this.$store.state.presentation.slides.length * 100}%`
      }
    },
  },
}

</script>

<style lang="scss" scoped>
.bottom-slide-progress-bar {
  height: 3px;
  width: 100%;
  z-index: 999;
  position: relative;
  .slide-progress-bar {
    height: 100%;
    transition: width 0.5s;
  }
  &.is-exporting-pdf {
    opacity: 0;
  }
}
</style>
